module.exports = __webpack_public_path__ + "img/SCION.1d66151.jpg";